export default function projects() {

    $('.popup-projects__close, .button-close').click(function (e) {
        e.preventDefault();
        window.history.back();
    });

    $('.popup-projects__minimize').click(function () {
        $('.popup-projects').addClass('close');
    });

    $('.popup-projects__toggle').click(function (e) {
        e.preventDefault();
        $('.popup-projects').toggleClass('close');
    });

    $('.button-projects').click(function (e) {
        e.preventDefault();
        console.log('click burger');
        $('.popup-projects').addClass('open');
        $('.popup-projects').removeClass('close');
    });

}


// WEBPACK FOOTER //
// ./scripts/modules/projects.js